import { render } from "./AddTandaDialog.vue?vue&type=template&id=611d6c5b"
import script from "./AddTandaDialog.vue?vue&type=script&lang=js"
export * from "./AddTandaDialog.vue?vue&type=script&lang=js"

import "./AddTandaDialog.vue?vue&type=style&index=0&id=611d6c5b&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__